// extracted by mini-css-extract-plugin
export default {"tooltip":"nO-z","arrow":"oO-z"};